/* import __COLOCATED_TEMPLATE__ from './bib-inline-edit.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class BibInlineEditComponent extends Component {
	@tracked isEditing = false;
	@tracked valueForEdit = this.args.model?.bib;

	@action
	handleKeyDown(event) {
		if (event.key === "Enter" || event.keyCode === 13) {
			event.preventDefault();
			this.save();
		}

		if (event.key === "Escape" || event.keyCode === 27) {
			this.cancel();
		}
	}

	@action
	toggleEditing(event) {
		if (event) {
			event.preventDefault();
		}
		if (!this.isEditing) {
			// When entering edit mode, sync the edit value with current model value
			this.valueForEdit = this.args.model?.bib;
		}
		this.isEditing = !this.isEditing;
	}

	@action
	updateValue(event) {
		this.valueForEdit = event.target.value;
	}

	@action
	save() {
		this.args.model.bib = this.valueForEdit;
		this.args.model.save();
		this.isEditing = false;
	}

	@action
	cancel() {
		// Reset to model value
		this.valueForEdit = this.args.model?.bib;
		this.isEditing = false;
	}
}